import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationData } from '../../services/confirmation.service';

@Component({
  selector: 'igx-confirmation-dialog',
  imports: [ButtonModule, AsyncPipe],
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent {
  private readonly _dialogConfig = inject(DynamicDialogConfig);
  private readonly _dialogRef = inject(DynamicDialogRef);
  public readonly _dialogData = this._dialogConfig.data as ConfirmationData;

  public handleSubmit(): void {
    this._dialogRef.close(true);
  }

  public handleCancel(): void {
    this._dialogRef.close(false);
  }
}
